module.exports = __webpack_public_path__ + "static/media/es.8c819b2f.png";